webpackJsonp([114276838955818,60335399758886],{

/***/ 199:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 301:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(322);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(199);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 12:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ButtonModule = __webpack_require__(36);
	
	var _ButtonModule2 = _interopRequireDefault(_ButtonModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	    var color = _ref.color,
	        text = _ref.text,
	        clicked = _ref.clicked,
	        styles = _ref.styles,
	        loading = _ref.loading,
	        _ref$disabled = _ref.disabled,
	        disabled = _ref$disabled === undefined ? false : _ref$disabled;
	
	
	    var buttonStyles = [_ButtonModule2.default.Button];
	    if (color === 'primary') {
	        buttonStyles = [_ButtonModule2.default.Button, _ButtonModule2.default.Primary].join(' ');
	    }
	
	    if (color === 'primary' && loading) {
	        buttonStyles = [_ButtonModule2.default.Button, _ButtonModule2.default.PrimaryButtonLoading].join(' ');
	    }
	
	    if (color === 'primary' && disabled) {
	        buttonStyles = [_ButtonModule2.default.Button, _ButtonModule2.default.PrimaryButtonDisabled].join(' ');
	    }
	
	    if (color === 'secondary') {
	        buttonStyles = [_ButtonModule2.default.Button, _ButtonModule2.default.Secondary].join(' ');
	    }
	
	    if (color === 'transparent') {
	        buttonStyles = [_ButtonModule2.default.Button, _ButtonModule2.default.Transparent].join(' ');
	    }
	
	    return _react2.default.createElement(
	        'button',
	        {
	            className: buttonStyles,
	            onClick: clicked,
	            style: styles,
	            disabled: loading ? loading : disabled },
	        loading ? "Chargement..." : text
	    );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 36:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Button":"src-components-Button----Button-module---Button---1lSPX","Primary":"src-components-Button----Button-module---Primary---3suM_","PrimaryButtonLoading":"src-components-Button----Button-module---PrimaryButtonLoading---3xicQ","PrimaryButtonDisabled":"src-components-Button----Button-module---PrimaryButtonDisabled---2iIO_","Secondary":"src-components-Button----Button-module---Secondary---3FwkJ","Transparent":"src-components-Button----Button-module---Transparent---1lisK"};

/***/ }),

/***/ 304:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Button = __webpack_require__(12);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _gatsbyLink = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CallToAction = function CallToAction(_ref) {
	    var type = _ref.type;
	
	    if (type === 'call') {
	        return _react2.default.createElement(
	            'button',
	            null,
	            'Appelez pour R\xE9server'
	        );
	    }
	    return _react2.default.createElement(_Button2.default, { color: 'primary', text: 'R\xE9server en ligne', clicked: function clicked() {
	            return (0, _gatsbyLink.navigateTo)({
	                pathname: '/reservation',
	                item: 'navigation'
	            });
	        } });
	};
	
	CallToAction.propTypes = {
	    type: _propTypes2.default.string
	};
	
	exports.default = CallToAction;
	module.exports = exports['default'];

/***/ }),

/***/ 308:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CallToAction = __webpack_require__(304);
	
	var _CallToAction2 = _interopRequireDefault(_CallToAction);
	
	var _google_conversion_mobile_call = __webpack_require__(11);
	
	var _google_conversion_mobile_call2 = _interopRequireDefault(_google_conversion_mobile_call);
	
	var _HeaderModule = __webpack_require__(429);
	
	var _HeaderModule2 = _interopRequireDefault(_HeaderModule);
	
	var _Logo = __webpack_require__(311);
	
	var _Logo2 = _interopRequireDefault(_Logo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Header = function Header() {
	
	    return _react2.default.createElement(
	        'div',
	        { className: _HeaderModule2.default.HeaderWrapper },
	        _react2.default.createElement(_Logo2.default, null),
	        _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                'div',
	                { className: _HeaderModule2.default.CallActionHeader },
	                _react2.default.createElement(
	                    'div',
	                    { className: _HeaderModule2.default.CallTitle },
	                    'Appelez pour prendre un rendez-vous'
	                ),
	                _react2.default.createElement(
	                    'a',
	                    { href: 'tel:+16132525227', className: _HeaderModule2.default.PhoneNumber, onClick: function onClick() {
	                            (0, _google_conversion_mobile_call2.default)();
	                        } },
	                    _react2.default.createElement(
	                        'strong',
	                        null,
	                        '613-252-5227'
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        'strong',
	                        null,
	                        _react2.default.createElement(
	                            'em',
	                            null,
	                            'ou'
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: _HeaderModule2.default.ReserveOnlineMobile },
	                    _react2.default.createElement(_CallToAction2.default, null)
	                )
	            )
	        )
	    );
	};
	
	exports.default = Header;
	module.exports = exports['default'];

/***/ }),

/***/ 429:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"CallTitle":"src-components-Header----Header-module---CallTitle---fJG3P","PhoneNumber":"src-components-Header----Header-module---PhoneNumber---1m_Jn","CallActionHeader":"src-components-Header----Header-module---CallActionHeader---1Ylhq","ReserveOnlineMobile":"src-components-Header----Header-module---ReserveOnlineMobile---3Wqsq","HeaderWrapper":"src-components-Header----Header-module---HeaderWrapper---2Qxna","MobileNav":"src-components-Header----Header-module---MobileNav---2Fj-U","MobileNavLinks":"src-components-Header----Header-module---MobileNavLinks---34tpd","Active":"src-components-Header----Header-module---Active---kt39h"};

/***/ }),

/***/ 311:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(2);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _LogoModule = __webpack_require__(430);
	
	var _LogoModule2 = _interopRequireDefault(_LogoModule);
	
	var _cpmCaLogoV3Fr = __webpack_require__(632);
	
	var _cpmCaLogoV3Fr2 = _interopRequireDefault(_cpmCaLogoV3Fr);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	    return _react2.default.createElement(
	        'div',
	        { style: { display: 'flex' } },
	        _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/', className: _LogoModule2.default.LogoImage },
	            _react2.default.createElement('img', { src: _cpmCaLogoV3Fr2.default, alt: 'Psy Scan Institute Logo', style: { width: '100%' } })
	        )
	    );
	};
	
	// import LogoIcon from '../../images/cpm-ca-logov2-fr.jpg'
	

	module.exports = exports['default'];

/***/ }),

/***/ 430:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"LogoImage":"src-components-Logo----Logo-module---LogoImage---3VWhG"};

/***/ }),

/***/ 13:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ButtonModule = __webpack_require__(38);
	
	var _ButtonModule2 = _interopRequireDefault(_ButtonModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	    var color = _ref.color,
	        text = _ref.text,
	        clicked = _ref.clicked,
	        styles = _ref.styles,
	        loading = _ref.loading,
	        _ref$disabled = _ref.disabled,
	        disabled = _ref$disabled === undefined ? false : _ref$disabled;
	
	
	    var buttonStyles = [_ButtonModule2.default.Button];
	    if (color === 'primary') {
	        buttonStyles = [_ButtonModule2.default.Button, _ButtonModule2.default.Primary].join(' ');
	    }
	
	    if (color === 'primary' && loading) {
	        buttonStyles = [_ButtonModule2.default.Button, _ButtonModule2.default.PrimaryButtonLoading].join(' ');
	    }
	
	    if (color === 'primary' && disabled) {
	        buttonStyles = [_ButtonModule2.default.Button, _ButtonModule2.default.PrimaryButtonDisabled].join(' ');
	    }
	
	    if (color === 'secondary') {
	        buttonStyles = [_ButtonModule2.default.Button, _ButtonModule2.default.Secondary].join(' ');
	    }
	
	    if (color === 'transparent') {
	        buttonStyles = [_ButtonModule2.default.Button, _ButtonModule2.default.Transparent].join(' ');
	    }
	
	    return _react2.default.createElement(
	        'button',
	        {
	            className: buttonStyles,
	            onClick: clicked,
	            style: styles,
	            disabled: loading ? loading : disabled },
	        loading ? "Loading..." : text
	    );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 38:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Button":"src-componentsEn-Button----Button-module---Button---2JTlm","Primary":"src-componentsEn-Button----Button-module---Primary---_dSAO","PrimaryButtonLoading":"src-componentsEn-Button----Button-module---PrimaryButtonLoading---1p514","PrimaryButtonDisabled":"src-componentsEn-Button----Button-module---PrimaryButtonDisabled---D3iR5","Secondary":"src-componentsEn-Button----Button-module---Secondary---aGVMu","Transparent":"src-componentsEn-Button----Button-module---Transparent---3PMbj"};

/***/ }),

/***/ 313:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Button = __webpack_require__(13);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _gatsbyLink = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CallToAction = function CallToAction(_ref) {
	    var type = _ref.type;
	
	    if (type === 'call') {
	        return _react2.default.createElement(
	            'button',
	            null,
	            'Call to Book an Appointment'
	        );
	    }
	    return _react2.default.createElement(_Button2.default, { color: 'primary', text: 'Book Online', clicked: function clicked() {
	            return (0, _gatsbyLink.navigateTo)({
	                pathname: '/en/booking',
	                item: 'navigation'
	            });
	        } });
	};
	
	CallToAction.propTypes = {
	    type: _propTypes2.default.string
	};
	
	exports.default = CallToAction;
	module.exports = exports['default'];

/***/ }),

/***/ 317:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CallToAction = __webpack_require__(313);
	
	var _CallToAction2 = _interopRequireDefault(_CallToAction);
	
	var _google_conversion_mobile_call = __webpack_require__(11);
	
	var _google_conversion_mobile_call2 = _interopRequireDefault(_google_conversion_mobile_call);
	
	var _HeaderModule = __webpack_require__(433);
	
	var _HeaderModule2 = _interopRequireDefault(_HeaderModule);
	
	var _Logo = __webpack_require__(320);
	
	var _Logo2 = _interopRequireDefault(_Logo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Header = function Header() {
	
	    return _react2.default.createElement(
	        'div',
	        { className: _HeaderModule2.default.HeaderWrapper },
	        _react2.default.createElement(_Logo2.default, null),
	        _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                'div',
	                { className: _HeaderModule2.default.CallActionHeader },
	                _react2.default.createElement(
	                    'div',
	                    { className: _HeaderModule2.default.CallTitle },
	                    'Call to Book an Appointment'
	                ),
	                _react2.default.createElement(
	                    'a',
	                    { href: 'tel:+16132525227', className: _HeaderModule2.default.PhoneNumber, onClick: function onClick() {
	                            (0, _google_conversion_mobile_call2.default)();
	                        } },
	                    _react2.default.createElement(
	                        'strong',
	                        null,
	                        '613-252-5227'
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        'strong',
	                        null,
	                        _react2.default.createElement(
	                            'em',
	                            null,
	                            'or'
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: _HeaderModule2.default.ReserveOnlineMobile },
	                    _react2.default.createElement(_CallToAction2.default, null)
	                )
	            )
	        )
	    );
	};
	
	exports.default = Header;
	module.exports = exports['default'];

/***/ }),

/***/ 433:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"CallTitle":"src-componentsEn-Header----Header-module---CallTitle---13wO5","PhoneNumber":"src-componentsEn-Header----Header-module---PhoneNumber---lOYAT","CallActionHeader":"src-componentsEn-Header----Header-module---CallActionHeader---3rH9j","ReserveOnlineMobile":"src-componentsEn-Header----Header-module---ReserveOnlineMobile---3COUi","HeaderWrapper":"src-componentsEn-Header----Header-module---HeaderWrapper---3jkeb","MobileNav":"src-componentsEn-Header----Header-module---MobileNav---voNr6","MobileNavLinks":"src-componentsEn-Header----Header-module---MobileNavLinks---M25AB","Active":"src-componentsEn-Header----Header-module---Active---35g6Z"};

/***/ }),

/***/ 320:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(2);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _LogoModule = __webpack_require__(434);
	
	var _LogoModule2 = _interopRequireDefault(_LogoModule);
	
	var _cpmCaLogoV = __webpack_require__(633);
	
	var _cpmCaLogoV2 = _interopRequireDefault(_cpmCaLogoV);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	    return _react2.default.createElement(
	        'div',
	        { style: { display: 'flex' } },
	        _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/en', className: _LogoModule2.default.LogoImage },
	            _react2.default.createElement('img', { src: _cpmCaLogoV2.default, alt: 'Psy Scan Institute Logo', style: { width: '100%' } })
	        )
	    );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 434:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"LogoImage":"src-componentsEn-Logo----Logo-module---LogoImage---gsbcK"};

/***/ }),

/***/ 632:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/cpm-ca-logo-v3-fr.9588e8f0.svg";

/***/ }),

/***/ 633:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/cpm-ca-logo-v3.3ba61b24.svg";

/***/ }),

/***/ 634:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/cpm-favicon.647bad2c.png";

/***/ }),

/***/ 436:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 322:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(15);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	__webpack_require__(436);
	
	var _Header = __webpack_require__(308);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Header3 = __webpack_require__(317);
	
	var _Header4 = _interopRequireDefault(_Header3);
	
	var _cpmFavicon = __webpack_require__(634);
	
	var _cpmFavicon2 = _interopRequireDefault(_cpmFavicon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Layout = function (_Component) {
	    _inherits(Layout, _Component);
	
	    function Layout() {
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, Layout);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	            isMobile: false,
	            mobileMenu: false,
	            isLoading: true,
	            gDeviceWidth: 1440
	        }, _this.updateDeviceState = function () {
	            if (window.innerWidth >= 768) {
	                _this.setState({ isMobile: window.innerWidth < 768, mobileMenu: false, gDeviceWidth: window.innerWidth });
	            } else {
	                _this.setState({ isMobile: window.innerWidth < 768, gDeviceWidth: window.innerWidth });
	            }
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    Layout.prototype.componentDidMount = function componentDidMount() {
	        var _this2 = this;
	
	        this.setState({
	            isMobile: window.innerWidth < 768,
	            isLoading: false
	        }, function () {
	            window.addEventListener("resize", _this2.updateDeviceState);
	        });
	    };
	
	    Layout.prototype.componentWillUnmount = function componentWillUnmount() {
	        window.removeEventListener("resize", this.updateDeviceState);
	    };
	
	    Layout.prototype.render = function render() {
	        var _this3 = this;
	
	        var pathname = this.props.location.pathname;
	
	
	        var headerStyles = {
	            boxShadow: '2px 0 4px 0 rgba(184, 183, 183, 0.5)'
	        };
	
	        return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                _reactHelmet2.default,
	                null,
	                _react2.default.createElement('link', { rel: 'icon', type: 'image/png', href: _cpmFavicon2.default }),
	                _react2.default.createElement('script', { async: true, src: 'https://www.googletagmanager.com/gtag/js?id=UA-121097236-1' }),
	                _react2.default.createElement(
	                    'script',
	                    null,
	                    '\n                        window.dataLayer = window.dataLayer || [];\n                        function gtag(){dataLayer.push(arguments);}\n                        gtag(\'js\', new Date());\n\n                        gtag(\'config\', \'UA-121097236-1\');\n                        gtag(\'config\', \'AW-997202270\');\n                        gtag(\'config\', \'AW-997202270/qnv-CIfCnoQBEN6ywNsD\', {\n                        \'phone_conversion_number\': \'613-252-5227\'\n                    });'
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { style: headerStyles },
	                pathname.substring(0, 3) === '/en' ? _react2.default.createElement(_Header4.default, _extends({}, this.state, {
	                    toggleMobileMenu: function toggleMobileMenu() {
	                        return _this3.setState({ mobileMenu: !_this3.state.mobileMenu });
	                    },
	                    closeMobileMenu: function closeMobileMenu() {
	                        _this3.setState({ mobileMenu: false });
	                    }
	                })) : _react2.default.createElement(_Header2.default, _extends({}, this.state, {
	                    toggleMobileMenu: function toggleMobileMenu() {
	                        return _this3.setState({ mobileMenu: !_this3.state.mobileMenu });
	                    },
	                    closeMobileMenu: function closeMobileMenu() {
	                        _this3.setState({ mobileMenu: false });
	                    }
	                }))
	            ),
	            this.props.children(_extends({}, this.props, this.state))
	        );
	    };
	
	    return Layout;
	}(_react.Component);
	
	Layout.propTypes = {
	    children: _propTypes2.default.func,
	    isMobile: _propTypes2.default.bool,
	    mobileMenu: _propTypes2.default.bool
	};
	exports.default = Layout;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-6e69ed4f9d147e57515b.js